import React from 'react'
import "./MyList.scss"

const MyList = () => {
  return (
    <div className='myList'>
    <div className="list1">Users can add to their lists, as soon as the backend work is done.</div>
    </div>
  )
}

export default MyList